import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";
import { Link } from "react-router-dom";

export default function FaqPage() {
  return (
    <div>
      <section className="py-16 lg:py-24 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm font-semibold tracking-[0.18em] uppercase text-[#081537] mb-3">FAQ</div>
          <h1 className="font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0F172A] text-balance max-w-3xl">
            Everything you wanted to know.
          </h1>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible data-testid="faq-list">
            {FAQS.map((f, idx) => (
              <AccordionItem key={idx} value={`item-${idx}`} className="border-b border-slate-200">
                <AccordionTrigger className="text-left text-base font-semibold text-[#0F172A] hover:text-[#081537] py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 bg-slate-50 rounded-2xl p-8 text-center border border-slate-100">
            <h3 className="font-[Outfit] text-2xl font-semibold text-[#0F172A]">Still have questions?</h3>
            <p className="mt-2 text-slate-600">Our team is happy to help. Reach out anytime.</p>
            <Link to="/contact" className="mt-5 inline-flex bg-[#081537] hover:bg-[#0F2152] text-white rounded-full px-6 py-3 font-semibold transition" data-testid="faq-contact-btn">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
